export const getApplicationSiteKey = (ref_Data) => {
  let SITE_KEY = "";
  try {
    const appConfig = ref_Data && ref_Data.ApplicationConfig;
    if (Array.isArray(appConfig)) {
      const found = appConfig.find(
        (cfg) =>
          cfg &&
          cfg.Captcha_Site_Key !== undefined &&
          cfg.Captcha_Site_Key !== null
      );
      if (found) SITE_KEY = found.Captcha_Site_Key || "";
    }
  } catch (err) {
    SITE_KEY = "";
  }
  return SITE_KEY;
};

export const getApplicationRegex = (ref_Data) => {
  let regex_Data = { Script_Regex: null, Emoji_Regex: null };

  const convertRegex = (regexString) => {
    const matches = regexString.match(/^\/(.*)\/([a-z]*)$/);
    const pattern = matches[1];
    const flags = matches[2];
    return new RegExp(pattern, flags);
  };

  try {
    const appConfig = ref_Data && ref_Data.ApplicationConfig;
    if (Array.isArray(appConfig)) {
      const Script_found = appConfig.find(
        (cfg) =>
          cfg &&
          cfg.Script_Regex !== undefined &&
          cfg.Script_Regex !== null
      );
      const Emoji_found = appConfig.find(
        (cfg) =>
          cfg &&
          cfg.Emoji_Regex !== undefined &&
          cfg.Emoji_Regex !== null
      );
      if (Script_found && Emoji_found) {
        regex_Data = {
          Script_Regex: convertRegex(Script_found.Script_Regex),
          Emoji_Regex: convertRegex(Emoji_found.Emoji_Regex),
        };
      } else {
        regex_Data = { Script_Regex: null, Emoji_Regex: null };
      }
    }
  } catch (err) {
    regex_Data = { Script_Regex: null, Emoji_Regex: null };
  }
  return regex_Data;
};



// WEBPACK FOOTER //
// ./src/mi-app/plugins/utils.js